import React, { FC } from 'react';
import { TripState } from 'src/types/trips/Trips';
import getClassName from 'src/common/utils/getClassName';
import s from './TripStateIndicatorCalendar.module.scss';

type Props = {
  classNameModifier?:string;
  tripState: TripState;
};

const TripStateIndicatorCalendar: FC<Props> = ({
  classNameModifier = '',
  tripState,
}) => {
  const modifiers = [
    classNameModifier,
    tripState?.state ?? '',
  ].join(' ');

  return (
    <li
      className={getClassName(s, 'root', modifiers)}
      data-test="TripStateIndicator"
    >
      {tripState?.badge ?? ''}
    </li>
  );
};

export default TripStateIndicatorCalendar;
